import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const Wrapper = styled(motion.div)`
  padding: 8px 0;
  display: flex;
  flex-direction: column;

  .btn-wrap {
    display: flex;
    gap: 14px;
    align-items: center;
    justify-content: center;
    .label {
      width: 180px;
      text-align: left;
      color: var(--pcm-body-color);
    }
    img {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }
  }
`;

export const WalletIconContainer = styled(motion.div)`
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 36px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  color: var(--pcm-body-color);
`;

export const Subtitle = styled(Title)`
  color: var(--pcm-body-color-secondary);
  margin-bottom: 32px;
  font-weight: 400;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;

  button {
    border-radius: var(--pcm-rounded-lg);
    border: 1px solid #eaecf0;
    background-color: #fff;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: #fff;
    }
  }
`;

export const Tip = styled(Subtitle)`
  color: var(--pcm-body-color-secondary);
  margin-bottom: 0px;
`;
